import React from 'react';

import {Loading} from 'Components/Partials';
import {PollResultsGraph} from 'Components/MainStage';

import AdminLayout from 'Pages/Admin/AdminLayout';

import Poll from 'Services/Api/Admin/MainStage/Polls';

import {Socket} from 'Services';

export default class Results extends React.Component {
    /**
     * @var state
     */
    state = {
        loading: true,
        sessionId: this.props.match.params.session,
        pollId: this.props.match.params?.poll,
        poll: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.fetchPoll();

        Socket.getConnection()
            .private(`main_stage_sessions.polls.${this.state.pollId}`)
            .listen('MainStagePollAnswered', (e) => {
                const {poll} = this.state;

                const index = poll.answers.findIndex(answer => e.answer_id === answer.id);

                poll.answers[index].submission_count = e.answer_submission_count;

                poll.submission_count = e.poll_submission_count;

                this.setState({
                    poll
                });
            });
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        Socket.getConnection()
            .leave(`main_stage_sessions.polls.${this.state.pollId}`);
    };

    /**
     * @method fetchPoll
     */
    fetchPoll = async () => {
        this.setState({loading: true});

        const request = await Poll.get({
            session: this.state.sessionId,
            poll: this.state.pollId,
        });

        if (request.success) {
            this.setState({
                loading: false,
                poll: request.data.data
            });
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {loading, sessionId, pollId, poll} = this.state;

        return (
            <AdminLayout title="Main Stage - Poll - Results">
                <div className="divide-y divide-gray-200 lg:col-span-9">
                    <div className="p-6 flex justify-between">
                        <button onClick={this.fetchPoll}>
                            Refresh
                        </button>
                    </div>

                    {loading && (
                        <div className="p-6">
                            <Loading />
                        </div>
                    )}

                    {!loading && poll && (
                        <div className="p-6">
                            <table className="w-full table-auto">
                                <thead>
                                    <tr>
                                        <th className="border px-4 py-2 text-left">Answer</th>
                                        {poll.type === 'ranking' ? (
                                            <th className="border px-4 py-2 text-left">Points</th>
                                        ) : null}
                                        <th className="border px-4 py-2 text-left">Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {poll.answers.map(a => {

                                    const count = a.submission_count || 0;
                                    return (
                                        <tr key={a.id}>
                                            <th className="border px-4 py-2 text-left">{a.answer}</th>
                                            {poll.type === 'ranking' ? (
                                                <td className="border px-4 py-2 text-left">
                                                    {a.submission_count ? (a.submission_count * (poll.answers.length - poll.answers.indexOf(a))) : 0}
                                                </td>
                                            ) : null}
                                            <td className="border px-4 py-2 text-left">
                                                {count} {poll.submission_count ?
                                                    '- ' + Math.round((count / poll.submission_count) * 100) + '%' :
                                                    ''}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>

                            <PollResultsGraph
                                session_id={sessionId}
                                poll_id={pollId}
                            />
                        </div>
                    )}
                </div>
            </AdminLayout>
        );
    }
}
